import React from 'react';
import { Check } from 'lucide-react';
import CheckedBadgeIcon from './CheckedBadgeIcon';
import UIStrings from '@/Utils/UIStrings';

function ExpertsBadgeTooltip(): React.JSX.Element {
    const listItems: Array<string> = [
        UIStrings.SoftAndHardSkillsRequiredForAGivenJobFunction,
        UIStrings.RightIndustryExpertIsIdentifiedAndAssigned,
        UIStrings.QuestionsBasedOnTheResearchFindings,
        UIStrings.ValidatedByALeadingPsychologist,
    ];

    return (
        <div className="text-foreground max-w-md text-left">
            <div className="flex flex-col gap-3">
                <div className="flex flex-row gap-4">
                    <div className="flex min-w-8 items-center">
                        <CheckedBadgeIcon />
                    </div>
                    <p className="text-sm leading-snug font-semibold">
                        {UIStrings.QualityTestsBuiltByIndustryExpertsValidatedByPsychologists}
                    </p>
                </div>
                <p className="text-sm leading-relaxed text-inherit">
                    {`${UIStrings.TalentMeshTestsAreCreatedByTheFollowingScientificMethod}:`}
                </p>
                <ul className="flex list-none flex-col gap-0 pt-2 pb-0">
                    {listItems.map((item) => (
                        <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-inherit">
                            <Check className="text-percentile-top mt-0.5 size-4 shrink-0" aria-hidden />
                            <span className="mb-3">{item}</span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default ExpertsBadgeTooltip;
